import React, { useState } from "react";
import "./ProductCard.css";
// import MenuDots from "../../assets/icons/Menu Dots.svg";
import TickCircleFilled from "../../assets/icons/tickCircleFilled.svg";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { stepsActions } from "../../store/steps-slice";
import MenuDots from "../../assets/images/MenuDots.svg"
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Popover } from "@mui/material";


const ProductCard = ({ img, title, price, body, steps, editIcon, deleteIcon, handleProductEdit, handleProductDelete, data, step2Data, step2, handleSelectedCard, link }) => {
  const dispatch = useDispatch();
  const [showOptions, setShowOptions] = useState(false);
  const [isMouseOver,setIsMouseOver]=useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const actionMenuOpen = Boolean(anchorEl);

  function handleEditProduct() {
    dispatch(stepsActions.handleRedirection(false));
    handleProductEdit(data.product_id);
    setShowOptions(false);
  }
  function handleDeleteProduct() {
    handleProductDelete(data.product_id);
    setShowOptions(false);
  }

  return (
    <div
      id={steps ? "stepsProductCard" : "productCard"}
      className={step2 && step2.product_id === data.product_id ? "stepsSelectedProductCard" : ""}
      onClick={(e) => steps && handleSelectedCard(data.product_id)}
      // onMouseEnter={() => setIsMouseOver(true)}
      // onMouseLeave={() => setIsMouseOver(false)}
    >
      <div className={steps ? "stepsImageSection" :  "imageSection" }>
        <img src={img} alt="product-img" />
        {!steps  && (
          <div onClick={(e) => setAnchorEl(e.currentTarget)}  className="menuDotsIcon">
            <MoreVertIcon onClick={() => setShowOptions(!showOptions)} />
          </div>
        )}
        {!steps && actionMenuOpen && (
          <Popover
         
          open={actionMenuOpen || isMouseOver}
          anchorEl={anchorEl}
          onClose={() =>setAnchorEl(null)}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <div className="productSettingOptions">
            <div className="productSettingOption" onClick={handleEditProduct}>
              <img src={editIcon} alt="edit-icon" />
              <p>Edit</p>
            </div>
            <hr />
            <div className="productSettingOption" onClick={handleDeleteProduct}>
              <img src={deleteIcon} alt="delete-icon" /> 
              <p>Delete</p>
            </div>
          </div>
          </Popover>
        )}
      </div>
      <div className={steps ? "stepsCard__info" : "card__info"}>
        <div className={steps ? "stepsCard__infoTop" : "card__infoTop"}>
          <h4>{title}</h4>
          <h4>{price}</h4>
        </div>
        <div className={steps ? "stepsCard__infoBottom" : "card__infoBottom"}>
          <p>{body}</p>
          {link && (
            <Link to="/products/add-new-product" onClick={() => dispatch(stepsActions.handleRedirection(true))}>
              Add new product
            </Link>
          )}
        </div>
      
      </div>
      {step2 && step2.product_id === data.product_id && <img className="stepsTickCircleFilled" src={TickCircleFilled} alt="tick-circle-filled-icon" />}
    </div>
  );
};

export default ProductCard;
